import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_42: FaireProductEntity = {
  token: "legacy_prod_abbott-42",
  type: "product",
  name: 'Medium Flower Bloom Bowl Green 5" D',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/003b4dc116d1bca358a6aa63f64a458a8b35f6e07fbc047f69815cbfed4eabdb.jpeg",
  priceDollars: 24,
  subcategory: "Serveware",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_kitchen-tabletop"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
